import classnames from 'classnames';
import React, { FC } from 'react';
import { HomeButtonName, useTrackMediaHomeAnalytics } from '../../../utils/hooks/bi/useTrackMediaHomeAnalytics';
import { HomeSlider } from '../HomeSlider';
import styles from './RecentFilesSection.scss';
import { IOuter } from './RecentFilesSection.types';

export const RecentFilesSection: FC<IOuter> = ({
  items,
  openExpandedView,
  buyItem,
  isItemSelected,
  selectedItems,
  isSecure,
  beginDrag,
  publicMediaCurrentCategory,
  onItemClick,
  onItemDoubleClick,
  onItemRightClick,
  dataHook,
  currentFolder,
}) => {
  const { trackRecentButtonClick } = useTrackMediaHomeAnalytics();

  const handleRecentButtonClick = (buttonName: HomeButtonName) => () => trackRecentButtonClick(buttonName);

  const recentItemsContent = (
    <>
      <HomeSlider
        dataHook={dataHook}
        items={items}
        buyItem={buyItem}
        isItemSelected={isItemSelected}
        selectedItems={selectedItems}
        isSecure={isSecure}
        beginDrag={beginDrag}
        publicMediaCurrentCategory={publicMediaCurrentCategory}
        openExpandedView={openExpandedView}
        onItemClick={onItemClick}
        onItemDoubleClick={onItemDoubleClick}
        onItemRightClick={onItemRightClick}
        onNavLeftClick={handleRecentButtonClick(HomeButtonName.NavLeft)}
        onNavRightClick={handleRecentButtonClick(HomeButtonName.NavRight)}
        currentFolder={currentFolder}
      />
    </>
  );

  return (
    <div className={classnames(styles.recentFilesHolder, { [styles.hiddenSection]: !items.length })}>
      {items.length ? recentItemsContent : null}
    </div>
  );
};
